import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { MailX, CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "working", company: "", already: false, error: "" });
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    const u = params.get("u") || "";
    const t = params.get("t") || "";
    if (!u || !t) { setState({ status: "error", error: "This unsubscribe link is incomplete." }); return; }
    api.post("/claim/unsubscribe", { u, t })
      .then(({ data }) => setState((s) => (s.status === "done" ? s : { status: "done", company: data.company, already: data.already })))
      .catch((e) => setState({ status: "error", error: e.response?.data?.detail || "This unsubscribe link is not valid." }));
  }, [params]);

  return (
    <div className="max-w-md mx-auto px-4 py-20 text-center" data-testid="unsubscribe-page">
      <Link to="/" className="inline-block mb-10" aria-label="Accommodation Suppliers — home">
        <img src="/brand/as-logo-stacked.png" alt="Accommodation Suppliers" className="h-24 w-auto mx-auto" />
      </Link>
      {state.status === "working" && <p className="text-sm text-[#7D8C85]" data-testid="unsubscribe-working">Updating your preferences…</p>}
      {state.status === "done" && (
        <div className="bg-white border border-[#E8ECE9] p-8" data-testid="unsubscribe-done">
          <CheckCircle2 className="w-10 h-10 mx-auto text-[#264839] mb-4" />
          <h1 className="font-serif text-2xl text-[#11211A] mb-3">{state.already ? "You're already unsubscribed" : "You've been unsubscribed"}</h1>
          <p className="text-sm text-[#4A5550] leading-relaxed">
            {state.company ? <><span className="font-medium text-[#11211A]">{state.company}</span> will</> : "You will"} receive no further emails about this listing.
          </p>
          <p className="text-xs text-[#7D8C85] mt-4 leading-relaxed">
            Your free listing stays live as it is. If you'd like it removed entirely, just email <a href="mailto:hello@accommodationsuppliers.com" className="underline">hello@accommodationsuppliers.com</a> with "remove" and we'll take it down right away.
          </p>
          <Link to="/" className="btn-primary text-xs mt-6 inline-flex" data-testid="unsubscribe-home">Back to AccommodationSuppliers.com</Link>
        </div>
      )}
      {state.status === "error" && (
        <div className="bg-white border border-[#E8ECE9] p-8" data-testid="unsubscribe-error">
          <XCircle className="w-10 h-10 mx-auto text-[#B35C4A] mb-4" />
          <h1 className="font-serif text-2xl text-[#11211A] mb-3">Link not recognised</h1>
          <p className="text-sm text-[#4A5550] leading-relaxed">{state.error}</p>
          <p className="text-xs text-[#7D8C85] mt-4 leading-relaxed">
            <MailX className="w-3.5 h-3.5 inline -mt-0.5 mr-1" />You can still opt out by replying "remove" to the email you received, or by writing to <a href="mailto:hello@accommodationsuppliers.com" className="underline">hello@accommodationsuppliers.com</a>.
          </p>
        </div>
      )}
    </div>
  );
}
